import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Trainers } from '../models/trainers';
import { TranslateService } from '@ngx-translate/core';
import { ModalRef, ModalService } from './modal.service';
import { MessageComponent } from '../modals/message/message.component';

export interface ResponseGet {
  items?: Array<any>;
  totalPages?: number;
}

@Injectable()
export class Utils {

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private modalService: ModalService,
  ) { }

  getTrainers(): Observable<Trainers> {
    return this.http.get<Trainers>(
      environment.apiName + '/trainers?campaignOnly=true',
      { 
        headers: this.getRequestHeaders()
      }
    );
  }

  getErrorMessage(error: any, email: string): string {
    let message = this.translate.instant('network_request_error');
    if (error.status == 400) {
      const code = error.error.code;
      message = this.translate.instant('fail_title');
      message += '<br><br>';
      if (code == 11007) {
        message += this.translate.instant('fail_1007', {'email': email});
      } else if (code == 11009) {
        message += this.translate.instant('fail_1009');
      } else if (code == 11012) {
        message += this.translate.instant('fail_1012', {'email': email});
      } else if (code == 10000) {
        message += this.translate.instant('fail_10000');
      } else {
        message += 'E' + code;
      }
    }
    return message;
  }

  getRequestHeaders() {
    return new HttpHeaders(
        {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        }
    );
  }

  showMessage(error: any, message: string): ModalRef | undefined {
    if (error.status !== 401 && error.status !== 403) {
      const modal = this.modalService.show(MessageComponent);
      modal.componentInstance.message.set(message);
      return modal;
    }
    return undefined;
  }
}
